import "./Home.css";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { HomeBannerSection } from "./HomeBannerSection";
import { HomeIntroSection } from "./HomeIntroSection";
import { HomeAboutSection } from "./HomeAboutSection";
import { useTranslation } from "react-i18next";
import { HomeQualitySection } from "./HomeQualitySection";
import Loader from "../utils/Loader";

export const Home = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [loadedImagesCount, setLoadedImagesCount] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (loadedImagesCount === 3) {
      setLoading(false);
    }
  }, [loadedImagesCount]);

  const handleImageLoad = () => {
    setLoadedImagesCount((prevCount) => prevCount + 1);
  };

  const scrollToSection = (sectionId, offset = 0) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>VH BuildUp! - {t("helmet.title.home")}</title>
        <meta name="description" content={t("helmet.meta.home")} />
      </Helmet>
      {loading && (
        <div className="loading-overlay">
          <Loader loading={loading} />
        </div>
      )}
      <div className={loading ? "hidden" : ""}>
        <HomeBannerSection
          scrollToSection={scrollToSection}
          onImageLoad={handleImageLoad}
        />
        <HomeIntroSection />
        <HomeAboutSection onImageLoad={handleImageLoad} />
        <HomeQualitySection />
      </div>
    </>
  );
};
